import { api } from './api';
import { User } from './userAuthApi';

// Project access types
export interface CaseAccessUser {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  role: 'Admin' | 'Consultant' | 'Pending';
  active: boolean;
  granted_at: string;
}

export interface UserCase {
  caseId: string;
  name: string;
  description?: string;
  status?: string;
  createdBy?: string;
  createdAt?: string;
  granted_at: string;
}

export interface AccessCheckResponse {
  user_id: string;
  case_id: string;
  has_access: boolean;
}

export interface BulkAccessRequest {
  user_ids: string[];
}

export interface BulkAccessResponse {
  message: string;
  case_id: string;
  successful: Array<{
    user_id: string;
    email: string;
  }>;
  failed: Array<{
    user_id: string;
    reason: string;
  }>;
  total_attempted: number;
  success_count: number;
  failure_count: number;
}

export interface GrantAccessResponse {
  message: string;
  user_id: string;
  case_id: string;
  granted_at: string;
}

export interface RevokeAccessResponse {
  message: string;
  user_id: string;
  case_id: string;
}

export interface CaseUsersResponse {
  case_id: string;
  users: CaseAccessUser[];
  total: number;
}

export interface UserCasesResponse {
  user_id: string;
  cases: UserCase[];
  total: number;
}

// Case Access API
export const caseAccessApi = {
  // Grant user access to a case
  grantAccess: (caseId: string, userId: string): Promise<GrantAccessResponse> =>
    api.post<GrantAccessResponse>(`/cases/${caseId}/access/users/${userId}`),

  // Revoke a user's access to a case
  revokeAccess: (caseId: string, userId: string): Promise<RevokeAccessResponse> =>
    api.delete<RevokeAccessResponse>(`/cases/${caseId}/access/users/${userId}`),

  // List all users who have access to a case
  listProjectUsers: (caseId: string): Promise<CaseUsersResponse> =>
    api.get<CaseUsersResponse>(`/cases/${caseId}/access/users`),

  // List cases user has access to
  listUserProjects: (userId: string): Promise<UserCasesResponse> =>
    api.get<UserCasesResponse>(`/cases/access/users/${userId}/projects`),

  // Check if a user has access to a project
  checkAccess: (caseId: string, userId: string): Promise<AccessCheckResponse> =>
    api.get<AccessCheckResponse>(`/cases/${caseId}/access/users/${userId}/check`),

  // Grant multiple users access to case
  grantBulkAccess: (
    caseId: string,
    request: BulkAccessRequest
  ): Promise<BulkAccessResponse> =>
    api.post<BulkAccessResponse>(`/cases/${caseId}/access/users/bulk`, request),
};
